import React from "react"
import { connect } from "react-redux"
import { largeTextCellConnection } from "app/static/frontend/sheets/selectors/column-selectors"
import { Cell } from "fixed-data-table-2"
import InputCell from "sheets/components/cells/InputCell"
import Tooltip from "app/static/frontend/components/Tooltip"
import PropTypes from "prop-types"
import { calculateHoverTextPosition } from "app/static/frontend/sheets/helper-functions"
import sheetConstants from "sheets/constants"
import { isFeatureEnabled } from "shared/featureflags/helperFunctions"
/**
 * a large, potentially multi-line text cell
 * Supports editing the cell contents
 */
export class LargeTextCell extends React.Component {
    renderLargeTextCellWithTooltip(props, calculatedPosition) {
        return (
            <Tooltip
                delayShow={props.delayShow}
                label={props.children}
                placement={calculatedPosition}
            >
                <Cell
                    style={{ textAlign: "left", whiteSpace: "normal" }}
                    {...props}
                >
                    {props.children}
                </Cell>
            </Tooltip>
        )
    }

    renderLargeTextCell = props => (
        <Cell
            style={{ textAlign: "left", whiteSpace: "normal" }}
            {...props}
        >
            {props.children}
        </Cell>
    )

    render() {
        if (this.props.editing && this.props.cellIsEditable) {
            return <InputCell type="textarea" {...this.props} />
        }

        if (this.props.shouldRenderTooltip) {
            return this.renderLargeTextCellWithTooltip(
                this.props,
                calculateHoverTextPosition(this.props.columnCount, this.props.columnIndex)
            )
        } else {
            return this.renderLargeTextCell(this.props)
        }
    }
}

LargeTextCell.propTypes = {
    columnCount: PropTypes.number,
    columnIndex: PropTypes.number,
    cellIsEditable: PropTypes.bool,
    editing: PropTypes.bool.isRequired,
    delayShow: PropTypes.number,
    label: PropTypes.string,
    placement: PropTypes.string,
    rowHeightFactor: PropTypes.number,
    shouldRenderTooltip: PropTypes.bool,
}

LargeTextCell.defaultProps = {
    cellIsEditable: true,
    delayShow: sheetConstants.CELL_TOOLTIP_DELAY,
    placement: "left",
    rowHeightFactor: 1,
    shouldRenderTooltip: false,
}

export default connect((state, props) => largeTextCellConnection(state, props))(LargeTextCell)
